export const isAppealAttribute = (productAttribute) => {
  if (!productAttribute) {
    return false;
  }
  return productAttribute.type === '申诉';
};

export const isAppealCourse = (course) => {
  if (!course) {
    return false;
  }
  const marker = course.type || course.name || '';
  return marker.includes('申诉');
};

export const isAppealLesson = (lesson) => {
  return isAppealAttribute(lesson.productAttribute) || isAppealCourse(lesson.course);
};
